<template>
    <section class="p-[16px]">
        <div class="mb-[16px] flex items-center justify-between">
            <h2 class="text-[18px] text-[#2b2b2b] font-light">Liste des profils</h2>
        </div>
        <div class="">
            <DepartementTableComponent />
        </div>
    </section>
</template>

<script>
import DepartementTableComponent from '@/components/tables/DepartementTable'
export default {
    name: 'DepartementView',
    components: {
        DepartementTableComponent,
    },
    data() {
        return {}
    },
}

</script>